import { render, staticRenderFns } from "./GroupTips.vue?vue&type=template&id=a181b654&scoped=true&"
import script from "./GroupTips.vue?vue&type=script&lang=js&"
export * from "./GroupTips.vue?vue&type=script&lang=js&"
import style0 from "./GroupTips.vue?vue&type=style&index=0&id=a181b654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a181b654",
  null
  
)

export default component.exports